import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Grade, GradeCreate, GradeFilter } from '../data/grade';

export function createGradeService(client: AxiosInstance) {
  return createCrudService<Grade, GradeCreate, GradeFilter>(
    client,
    '/master-data/Grade',
    'id',
  );
}

export type GradeService = CrudService<Grade, GradeCreate, GradeFilter>;
